import { Card } from "antd";

const ReviewsOrderDetails = ({
  orderno,
  sname,
  datetime,
  business,
  businessImg,
  type,
}) => {
  return (
    <>
      <Card className="mx-2.5 mt-2 shadow-md ">
        <div className="sm:grid sm:grid-cols-5 sm:justify-between mx-2.5 my-1 grid grid-cols-2">
          <div>
            <p className="text-primaryPurple font-medium">Order Nr.</p>
            <span className="font-medium">{orderno}</span>
          </div>
          <div>
            <p className="text-primaryPurple font-medium">Service Name</p>
            <span className="font-medium">{sname}</span>
          </div>
          <div>
            <p className="text-primaryPurple font-medium">Order Date & Time</p>
            <span className="font-medium">{datetime}</span>
          </div>
          <div className="hidden sm:block"></div>
          <div className="sm:grid sm:justify-end">
            <p className="text-primaryPurple font-medium">{type}</p>
            <div className="flex items-center">
              <img src={businessImg} alt="" className="h-3 w-3 rounded-full" />
              <span className="ml-1 font-medium">{business}</span>
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};
export default ReviewsOrderDetails;
